import { IIsiUIFlowResult } from "../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { IsiPlBusiness, ParamPlBusiness } from "../Isilog/PresentationLogic/IsiPlBusiness";

export function IsiEntity(colFields,colOtherFields) {    
    ///////////////////////////////////////////////////////////////////////////////////
    // Attributs
    ///////////////////////////////////////////////////////////////////////////////////       
    // Collection pour stocker les valeurs des champs de l'entite
    this.pFields = colFields;
    // Collection pour stocker des informations diverses et variees de l'entite
    this.pOtherFields = colOtherFields;
    // Fonction qui permet d'acceder a la valeur d'un champ.
    // Si le champ n'existe pas dans la collection, la valeur retournee est vide.
    this.IsiGetFieldValue = function(keyField) 
    {
        var sRet;

        if (this.pFields[keyField]) {
            sRet = this.pFields[keyField];
        }
        else {
            sRet = "";
        }
        return sRet;
    }

    /*-- CREATION -----------------------------------------------------------------------------
    '- Auteur      : CEGO
    '- Date        : 29/06/2010
    '- Description : Traitement Ajax pour renseigner des donnees connexes en session utilisees
    '- (OTHERFIELD) par le composant metier.
    '-----------------------------------------------------------------------------------------*/
    this.iws_BusinessSetDataOnServer = function (): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, _reject) => {
            if (this.pOtherFields) {
                const setBusiness: IsiPlBusiness = new IsiPlBusiness();

                const opts: ParamPlBusiness = {
                    infosOtherFieldsEntity: this.pOtherFields
                }
                setBusiness.SetBusinessData(opts).then((setResult) => {
                    resolve(setResult);
                });
            } else {
                resolve({result:true,continue:true });
            }
            
        });
    }
}